module.exports = __webpack_public_path__ + "img/product_hardware.5bc5f5ee.png";